import React from "react";
import classNames from "classnames";
import { RichTextInput } from "@common/richTextInput";
import { Popup } from "@common/popup";
import { Props } from "./types";
import styles from "./styles.scss";

function RichTextForm({
  value,
  name,
  readOnly,
  disabled,
  flexible,
  edit,
  submit,
}: Props) {
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);

  if (readOnly) {
    return (
      <div
        className={classNames(styles.readOnly, { [styles.preview]: !flexible })}
        dangerouslySetInnerHTML={{ __html: value || "" }}
      />
    );
  }

  if (!flexible) {
    return (
      <>
        <div
          className={classNames(styles.preview, {
            [styles.disabled]: disabled,
          })}
          onClick={() => !disabled && setIsPopupOpen(true)}
        >
          <div
            className={styles.previewContent}
            dangerouslySetInnerHTML={{ __html: value || "" }}
          />
        </div>
        {isPopupOpen && (
          <Popup
            close={() => {
              submit(value);
              setIsPopupOpen(false);
            }}
          >
            <div className={styles.popupEditor}>
              {name && <p className={styles.popupTitle}>{name}</p>}
              <RichTextInput value={value || ""} placeholder="-" input={edit} />
            </div>
          </Popup>
        )}
      </>
    );
  }

  return (
    <div
      className={classNames(styles.richTextForm, {
        [styles.disabled]: disabled,
      })}
    >
      <RichTextInput
        value={value || ""}
        placeholder="-"
        isDisabled={disabled}
        autoToolbar
        isResizable
        input={edit}
        onChange={() => submit(value)}
      />
    </div>
  );
}

export { RichTextForm };
